import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, Output, Renderer2 } from '@angular/core';

/** Modal presentation only; the caller owns dismissal and its result/reason. */
@Component({
  selector: 'app-dialog-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss']
})
export class DialogHeaderComponent implements AfterViewInit {
  private static nextId = 0;
  @HostBinding('class') readonly hostClass = 'modal-header ia-dialog-header';
  @Input() titleId = `ia-dialog-title-${DialogHeaderComponent.nextId++}`;
  @Input() description: string;
  @Output() dismissed = new EventEmitter<void>();

  constructor(private element: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const dialog = this.element.nativeElement.closest('[role="dialog"], [role="alertdialog"]');
    if (!dialog) return;
    // Existing modal options take precedence over the shared heading fallback.
    if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
      this.renderer.setAttribute(dialog, 'aria-labelledby', this.titleId);
    }
    if (this.description && !dialog.getAttribute('aria-describedby')) {
      this.renderer.setAttribute(dialog, 'aria-describedby', `${this.titleId}-description`);
    }
  }
}
